import { TurnstileFormikField } from 'hb-react/shared/components/Turnstile/TurnstileFormikField';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';
import { FormikRecaptcha } from 'hb-react/shared/utils/recaptcha';

export const CaptchaFormikField = () => {
  const { flagEvRecaptchaToTurnstile } = useFeatureFlag();

  return flagEvRecaptchaToTurnstile ? (
    <TurnstileFormikField />
  ) : (
    <FormikRecaptcha />
  );
};
